/* eslint vue/no-parsing-error: 0 */
<template>
  <chart-svg
    v-bind="$props"
    ref="svg"
    :xmlns="'http://www.w3.org/2000/svg'"
    @mousemove="$emit('mousemove', $event)"
    @mouseleave="$emit('mouseleave', $event)"
  >
    <slot />
  </chart-svg>
</template>

<script>
import { ChartSvg } from './chartsBase.styles';

export default {
  components: { ChartSvg },
  provide() {
    function cursorPoint(x, y) {
      const { svg } = this.$refs;
      const pt = svg.$el.createSVGPoint();
      pt.x = x;
      pt.y = y;
      return pt.matrixTransform(svg.$el.getScreenCTM().inverse());
    }

    return {
      cursorPoint: cursorPoint.bind(this),
    };
  },
};
</script>
